module.exports = __webpack_public_path__ + "static/media/arrow-down-wh.cdb5b7b6.svg";